import React from "react";
import BusinessPage from "../../../layout/BusinessPage";

export default function PreviewPanel({ t, sections, footer, nav, whatsapp, previewSlug, onSectionClick }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
      <div className="p-5 border-b">
        <div className="font-bold text-gray-900">{t("manager.preview.title", "Live Preview")}</div>
        <div className="text-sm text-gray-500">
          {t("manager.preview.subtitle", "Click any section to edit it")}
        </div>
      </div>

      <div className="p-3">
        <div className="border-4 border-gray-200 rounded-2xl overflow-hidden">
          <BusinessPage
            isPreview={true}
            previewConfig={{ sections, footer, nav, whatsapp }}
            slugOverride={previewSlug}
            onSectionClick={onSectionClick}
          />
        </div>
      </div>
    </div>
  );
}